<template>
    <div class="container-fluid__with-padding">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8 col-12">
                <template v-if="activities">
                        <div class="type" v-for="activity in activities">{{ activity.name }}</div>
                </template>
                <template v-else-if="types">
                    <template v-for="type in types">
                        <div class="type mr-1" v-if="type !== null">{{ type.name }}</div>
                    </template>
                </template>
                <h1 class="title">{{ title }}
                    <div class="subitem">
                        <span class="nationality">{{ nationalitiesFormatted }}</span>
                    </div>
                </h1>
<!--                <div class="col-6 no-gutters p-0 margin_negative_1">
                        <span v-for="subcategory in subcategories" class="tags" :style="{ backgroundColor: colorSubcategory}">
                        {{ subcategory.name }}
                        </span><span v-for="label in labels" class="tags" :style="{ backgroundColor: colorLabel}">
                        {{ label.name }}
                        </span>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Title",
        props: {
            title: '',
            type: '',
            types: null,
            activities: null,
            labels: null,
            subcategories: null,
            nationalities: null,
            colorLabel: null,
            colorSubcategory: null
        },
        computed: {
            nationalitiesFormatted() {
                if (this.nationalities) {
                    return this.nationalities.join(' / ');
                }
            }
        },
    }
</script>

